import { h } from 'vue'
import type { IconSet, IconProps } from 'vuetify'

// Custom Icon Components
import board from "../components/icons/Board.vue"
import chart from "../components/icons/Chart.vue"
import checkList from "../components/icons/CheckList.vue"
import home from "../components/icons/Home.vue"
import logout from "../components/icons/Logout.vue"
import pill from "../components/icons/Pill.vue"
import search from "../components/icons/Search.vue"
import send from "../components/icons/Send.vue"
import download from "../components/icons/Download.vue"
import addPerson from "../components/icons/AddPerson.vue"

const customSvgIconComponents = {
  addPerson,
  board,
  chart,
  checkList,
  download,
  home,
  logout,
  pill,
  search,
  send,
};

const customSVGs: IconSet = {
  component: (props: IconProps) => h(customSvgIconComponents[props.icon]),
}

export { customSVGs }
